// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useEffect, useState } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import { Glyphicon } from 'react-bootstrap';

import { useFetchData } from '../../../../infrastructure/hooks/useFetchData';
import { Activity } from '../../../../types/Activity';
import { getActivityByCity } from '../../../../api/ActivitiesApi';
import { Party } from '../../../../types/Party';
import { ApiStatus } from '../../../../infrastructure/constants/apiStatus';

import EventBookableActivities from './EventBookableActivities';
import EventNonBookableActivities from './EventNonBookableActivities';
import EventIdeas from './EventIdeas';
import EventFormNavigation from './EventFormNavigation';

const StyledTitle = styled.h3`
  font-size: 22px;
  margin-bottom: 15px;
`;

const StyledLoadingContainer = styled.div`
  display: flex;
  item-align: center;
  justify-content: center;
`;

const StyledNote = styled.p`
  font-size: 18px;
  margin-bottom: 20px;
`;

const EventFormTabs = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  party,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  ideas,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  addEventToState,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  closeModal,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  children,
}) => {
  const [selectedTab, setSelectedTab] = useState('regular');

  const { partyLocation } = (party as Party) ?? {};
  const { address } = partyLocation ?? {};
  const [apiStatus, activities = [], fetchActivities] = useFetchData<
    Activity[]
  >();

  const bookableActivities = activities.filter(activity => activity.bookable);

  const nonBookableActivities = activities.filter(
    activity => !activity.bookable
  );

  useEffect(() => {
    if (!address) return;
    fetchActivities(() => getActivityByCity(address, true));
  }, [address, fetchActivities]);

  const renderTab = () => {
    switch (selectedTab) {
      case 'ideas':
        return <EventIdeas ideas={ideas}>{children}</EventIdeas>;

      case 'non-bookable':
        return (
          <EventNonBookableActivities activities={nonBookableActivities}>
            {children}
          </EventNonBookableActivities>
        );

      case 'bookable':
        return (
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <EventBookableActivities
            activities={bookableActivities}
            party={party}
            addEventToState={addEventToState}
            closeModal={closeModal}
          >
            {children}
          </EventBookableActivities>
        );

      default:
        return <>{children}</>;
    }
  };

  if (apiStatus === ApiStatus.loading) {
    return (
      <StyledLoadingContainer>
        <Glyphicon glyph='refresh' className='spinning' />
      </StyledLoadingContainer>
    );
  }
  return (
    <>
      <StyledTitle>Add an Event</StyledTitle>
      <StyledNote>
        Pick how you want to add an event to the party itinerary.
      </StyledNote>
      <EventFormNavigation
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      {renderTab()}
    </>
  );
};

export default React.memo(EventFormTabs);
